import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const TableEngagementActionItemsSkeleton = () => {
  return [...Array(10)].map(() => (
    <tr key={uuidv4()} className={style.skeletonRow}>
      {[...Array(11)].map(() => (
        <td key={uuidv4()}>
          <SkeletonBlock className={style.skeletonText} />
        </td>
      ))}
    </tr>
  ));
};

export default TableEngagementActionItemsSkeleton;
